<template>
  <div class="page about-page">
    <div class="breadcrumb__container">
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item v-for="(item, i) in breadcrumbs" :key="i" class="breadcrumb__link">
          {{ item }}
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div >
      <h1>О системе</h1>

      <div class="">
        <a-row type="flex" :gutter="20">
          <a-col flex="1">
            <div class="block-wrapper">
              <h2 class="header">Версия системы: {{ version }}</h2>
              <p>
                Больши́е да́нные (англ. big data, [ˈbɪɡ ˈdeɪtə]) — обозначение структурированных и
                неструктурированных данных огромных объёмов и значительного многообразия, эффективно
                обрабатываемых горизонтально масштабируемыми программными инструментами,
                появившимися в конце 2000-х годов и альтернативных традиционным системам управления
                базами данных и решениям класса Business Intelligence[1][2][3].
                </br>
                </br>
                В широком смысле о «больших данных» говорят как о социально-экономическом феномене,
                связанном с появлением технологических возможностей анализировать огромные массивы
                данных, в некоторых проблемных областях — весь мировой объём данных, и вытекающих из
                этого трансформационных последствий[4].
              </p>
            </div>
          </a-col>
          <a-col flex="1">
            <div class="block-wrapper">
              <h2 class="header">Оборудование</h2>
              <the-table
                class="table"
                :config="tableHeader"
                :defaultSort="[]"
                :data="tableData"
                :canHideColumns="false"
              />
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import TheTable from "@/pages/table/table/TheTable.vue"
const tableHeader = {
  displayFields: [
    {
      label: 'Тип оборудования',
      field: 'Тип оборудования',
      index: 'Тип оборудования',
      name: 'Тип оборудования',
      width: 300
    },
    {
      label: 'Наименование модели',
      field: 'Наименование модели',
      index: 'Наименование модели',
      name: 'Наименование модели',
    },
  ]
}
const tableData = {
      rows: [
        { 'Тип оборудования': 'Процессор', 'Наименование модели': 'Intel® Xeon® E-2236 [6 ядер, 12 потоков, 3.4 ГГц, 12 МБ кэш, 80 Вт]' },
        { 'Тип оборудования': 'Оперативная память', 'Наименование модели': '64 ГБ: 4 x 16 ГБ DDR4 UDIMM ECC' },
        { 'Тип оборудования': 'Конфигурация платы', 'Наименование модели': 'UP, C242, 4DIMM, 6xSATA3, 1 PCI-E 3.0 x8 (in x16), 2 PCI-E 3.0 x4 (in x8), 1M.2 PCI-E, 2GLAN i210, 4USB, VGA, COM, IPMI 2.0 & iKVM с выделенным портом' },
        { 'Тип оборудования': 'Модуль удаленного управления', 'Наименование модели': 'Интегрированный IPMI 2.0 + KVM-over-LAN с выделенным портом' },
        { 'Тип оборудования': 'Блок питания', 'Наименование модели': 'Блок питания 350W' },
        { 'Тип оборудования': 'Дисковый массив', 'Наименование модели': '2 x 6000 ГБ SATA-накопитель (7200 об/мин)' },
        { 'Тип оборудования': 'Слот расширения', 'Наименование модели': 'Сетевой контроллер HBA, 2 порта, 16 Гбит/с, FC, SFP+, трансиверы SR' },
        { 'Тип оборудования': 'Контроллер', 'Наименование модели': 'Интегрированный: 6x SATA3 (6 Гбит/с) через C242; RAID 0, 1, 5, 10' },
        { 'Тип оборудования': 'Гарантия и дополнительный сервис', 'Наименование модели': 'Стандартная ONS2S - на месте эксплуатации сервера 2 года (при наличии СЦ в городе)' },
        { 'Тип оборудования': 'Руководство пользователя', 'Наименование модели': 'Руководство пользователя' },
        { 'Тип оборудования': 'Процессор', 'Наименование модели': 'Intel® Xeon® E-2236 [6 ядер, 12 потоков, 3.4 ГГц, 12 МБ кэш, 80 Вт]' },
        { 'Тип оборудования': 'Оперативная память', 'Наименование модели': '64 ГБ: 4 x 16 ГБ DDR4 UDIMM ECC' },
        { 'Тип оборудования': 'Конфигурация платы', 'Наименование модели': 'UP, C242, 4DIMM, 6xSATA3, 1 PCI-E 3.0 x8 (in x16), 2 PCI-E 3.0 x4 (in x8), 1M.2 PCI-E, 2GLAN i210, 4USB, VGA, COM, IPMI 2.0 & iKVM с выделенным портом' },
        { 'Тип оборудования': 'Модуль удаленного управления', 'Наименование модели': 'Интегрированный IPMI 2.0 + KVM-over-LAN с выделенным портом' },
        { 'Тип оборудования': 'Блок питания', 'Наименование модели': 'Блок питания 350W' },
        { 'Тип оборудования': 'Дисковый массив', 'Наименование модели': '2 x 6000 ГБ SATA-накопитель (7200 об/мин)' },
        { 'Тип оборудования': 'Слот расширения', 'Наименование модели': 'Сетевой контроллер HBA, 2 порта, 16 Гбит/с, FC, SFP+, трансиверы SR' },
        { 'Тип оборудования': 'Контроллер', 'Наименование модели': 'Интегрированный: 6x SATA3 (6 Гбит/с) через C242; RAID 0, 1, 5, 10' },
        { 'Тип оборудования': 'Гарантия и дополнительный сервис', 'Наименование модели': 'Стандартная ONS2S - на месте эксплуатации сервера 2 года (при наличии СЦ в городе)' },
        { 'Тип оборудования': 'Руководство пользователя', 'Наименование модели': 'Руководство пользователя' },
      ],
    }
export default {
  name: "about",
  components: {
    TheTable
  },
  data() {
    return {
      tableData,
      tableHeader,
      breadcrumbs: ["Главная", "О системе"]
    }
  },
  computed:{
    version() {
      return process.env.VUE_APP_FE_VERSION || '2.1';
    },
  }
}
</script>

<style scoped>
.table {
  @include scrollbars();
  max-height: 50vh;
  padding: 10px 0px 0;
  overflow-y: auto;
}
.breadcrumb__container {
  padding: 0 !important;
}
</style>
